// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  raceId: __t.u64().primaryKey().name("race_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  aId: __t.u64().name("a_id"),
  bId: __t.u64().name("b_id"),
  aFaction: __t.string().name("a_faction"),
  bFaction: __t.string().name("b_faction"),
  state: __t.string(),
  winnerId: __t.u64().name("winner_id"),
  opensAt: __t.timestamp().name("opens_at"),
  tallyAt: __t.timestamp().name("tally_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
